export default "__VITE_ASSET__1f783c58__"